import React from "react";
import ReactDOM from "react-dom/client";

import "./global-styles.css";
import Gallery from "./components/Gallery";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<Gallery />);
